import { useState } from "react";
import { getCandidateFiles } from "services/candidates";

export const useGetCandidateFiles = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState(null);

  const getFiles = async (candidateID) => {
    setIsLoading(true);

    const response = await getCandidateFiles(candidateID);
    setFiles(response);

    setIsLoading(false);
  };

  return { getFiles, files, isLoading };
};
